module.exports = __webpack_public_path__ + "static/img/zhiye2.9636dc27.png";